// Maps our weird BE values to display labels.
// TODO(James) get from CMS
export const levelToLabel = {
  Low: 'mellow',
  Moderate: 'active',
  High: 'very active',
};
export const PRODUCT_TYPES = {
  fresh: 'fresh',
  dry: 'dry',
  mixed: 'mixed',
};

export const STATE = {
  initial: 'initial',
  mealprep: 'mealprep',
  fresh: 'recipes/fresh',
  baked: 'recipes/baked',
  submitCart: 'submit',
  checkout: 'checkout',
};

export const ACTION_TYPES = {
  initialLoad: 'initialLoad',
  selectedMealprep: 'selectedMealprep',
  selectedFreshRecipes: 'selectedFreshRecipes',
  selectedBakedRecipes: 'selectedBakedRecipes',
  goBack: 'goBack',
};

export const ACTIONS = {
  initialLoad: (payload = {}) => ({
    payload,
    type: ACTION_TYPES.initialLoad,
  }),
  selectedMealprep: (payload = {}) => ({
    payload,
    type: ACTION_TYPES.selectedMealprep,
  }),
  selectedFreshRecipes: (payload = {}, props) => ({
    payload,
    type: ACTION_TYPES.selectedFreshRecipes,
    props,
  }),
  selectedBakedRecipes: (payload = {}, props) => ({
    payload,
    type: ACTION_TYPES.selectedBakedRecipes,
    props,
  }),
  goBack: (payload = {}) => ({
    payload,
    type: ACTION_TYPES.goBack,
  }),
};

export const STATE_TO_STEP_REFERENCE = {
  [STATE.mealprep]: 0,
  [STATE.fresh]: 1,
  [STATE.baked]: 1,
  [STATE.submitCart]: 1,
  [STATE.checkout]: 2,
};
